var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17157 5.67157C2 6.84315 2 8.72876 2 12.5C2 16.2712 2 18.1569 3.17157 19.3284C4.34315 20.5 6.22876 20.5 10 20.5H14C17.7712 20.5 19.6569 20.5 20.8284 19.3284C22 18.1569 22 16.2712 22 12.5C22 8.72876 22 6.84315 20.8284 5.67157C19.6569 4.5 17.7712 4.5 14 4.5H10C6.22876 4.5 4.34315 4.5 3.17157 5.67157ZM18.5762 8.01986C18.8413 8.33807 18.7983 8.81099 18.4801 9.07617L16.2837 10.9066C15.3973 11.6452 14.6789 12.2439 14.0448 12.6517C13.3843 13.0765 12.7411 13.3449 12 13.3449C11.2589 13.3449 10.6157 13.0765 9.95518 12.6517C9.32112 12.2439 8.60271 11.6452 7.71636 10.9066L5.51986 9.07617C5.20165 8.81099 5.15866 8.33807 5.42383 8.01986C5.68901 7.70165 6.16193 7.65866 6.48014 7.92383L8.63903 9.72291C9.57199 10.5004 10.2197 11.0384 10.7666 11.3901C11.2959 11.7306 11.6549 11.8449 12 11.8449C12.3451 11.8449 12.7041 11.7306 13.2334 11.3901C13.7803 11.0384 14.428 10.5004 15.361 9.72291L17.5199 7.92383C17.8381 7.65866 18.311 7.70165 18.5762 8.01986Z",
    fill: "#00A991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFill);
export default __webpack_public_path__ + "static/media/mail-fill.180bd7bd94e940e1e43ee0c6bd88e972.svg";
export { ForwardRef as ReactComponent };